import { render, staticRenderFns } from "./ProjectsAuthorizations.vue?vue&type=template&id=71d763a7"
import script from "./ProjectsAuthorizations.vue?vue&type=script&lang=js"
export * from "./ProjectsAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports